import React from "react";
import logger from "logger";
import * as TaskService from "Utils/TaskService";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";

export default function(props) {
  const { task } = props;
  if (task.taskstatus === "Completed") {
    return null;
  }

  const getUpdatedStatus = function(taskId) {
    TaskService.updateTaskStatus(taskId);
  };

  const stopTask = function(taskId) {
    TaskService.stopTask(taskId, function() {
      TaskService.stopTask(taskId);
    });
  };

  return (
    <CardActions style={{ "vertical-align": "bottom" }}>
      <span style={{ flex: "1" }} />
      <Button
        className="toolbarbutton"
        onClick={() => getUpdatedStatus(task.taskid)}
        style={{
          font: "15px arial, sans-serif",
          border: "thin",
          backgroundColor: "var(--menubarbackgroundcolor)",
          maxWidth: "100px",
        }}
      >
        Refresh
      </Button>
      <Button
        className="toolbarbutton"
        onClick={() => stopTask(task.taskid)}
        style={{
          font: "15px arial, sans-serif",
          border: "thin",
          backgroundColor: "red",
          maxWidth: "100px",
        }}
      >
        Stop
      </Button>
    </CardActions>
  );
}
